import { Popup } from "./popup";
import { windowWidth } from "./utils";

const mobMenu = {
  nextLevel: document.querySelectorAll(".jsNextLevel") as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(".jsPrevLevel") as NodeListOf<HTMLElement>,
  advertMenu: document.getElementById('advertMenu') as HTMLElement,
  advertMenuDesktop: document.getElementById('advertMenuDesktop') as HTMLElement,
  advertWrap: document.querySelectorAll('.jsAdvertWrapMobile') as NodeListOf <HTMLElement>,
  advertWrapDesktop: document.querySelectorAll('.jsAdvertWrapDesktop') as NodeListOf <HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,
  

  init() {


    if (windowWidth < 1024) {
    this.setNextLevel()
    this.setPrevLevel()
      const menu = new Popup("#mobMenu", "#jsOpenMenu", "#jsCloseMenu");
      menu.init();
      const finderPopupMob = new Popup("#jsFinderWrap", "#jsOpenFinderMob", "#jsCloseFinder");
      finderPopupMob.init();
      const search = new Popup("#mobSearch", "#openSearch", "#jsCloseMenu");
      search.init();
    }
      const finderPopup = new Popup("#jsFinderWrap", "#jsOpenFinder", "#jsCloseFinder");
      finderPopup.init();

      const filterPopup = new Popup("#jsFilterWrap", "#jsOpenFilter", "#jsCloseFilter");
      filterPopup.init();
  }, 
  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement
      if (subMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault()          
          subMenu.classList.add("activeClass")        
        })
      }

      this.close.addEventListener('click', (e) => {
        subMenu.classList.remove("activeClass")  
      });
    })
  },


  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement
      if (menu) {
        item.addEventListener("click", () => {                  
          menu?.classList.remove("activeClass")        
        })
      }
      this.close.addEventListener('click', (e) => {
        menu?.classList.remove("activeClass")  
      });
    })
  },


}

export default mobMenu
